import Loading from '@/common/components/Loading';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { PageWrapper } from '@/common/styles/Wrappers';
import React, { useState } from 'react';
import { ContentWrapper } from './Spends.styled';
import ActionButton from '@/common/components/buttons/ActionButton';
import SpendsTable from './components/spendsTable/SpendsTable';
import ImportSpendForm from './components/importSpendsForm/ImportSpendForm';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { getMetaSpends } from '@/API/repositories/meta';
import SpendsSearchBox from './components/spendsSearchBox/SpendsSearchBox';
import useSpendsSearchBox from './hooks/useSpendsSearchBox';

const Spends = () => {
	const [spends, setSpends] = useState([]);
	const [isImportFormOpen, setIsImportFormOpen] = useState();

	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const useSpendsSearchBoxHook = useSpendsSearchBox();

	const loadData = async () => {
		const dateFrom = new Date(
			useSpendsSearchBoxHook.dateFromRef.current.value,
		).toISOString();
		const dateTo = new Date(
			useSpendsSearchBoxHook.dateToRef.current.value,
		).toISOString();

		const payload = {
			dateFrom,
			dateTo,
		};
		const response = await makeRequest(getMetaSpends.bind(null, payload));
		if (!response?.data) {
			return addMessage('Loading error', 'error');
		}
		setSpends(() => response.data);
	};

	const handleCloseForm = () => {
		setIsImportFormOpen(() => false);
	};

	return (
		<PageWrapper>
			{hasUnfilledRequest(getMetaSpends) && <Loading />}
			<ContentWrapper>
				<SpendsSearchBox
					hook={useSpendsSearchBoxHook}
					onSearchClick={loadData}
				/>
				<ActionButton
					style={{ height: 'fit-content' }}
					defaultText='Import spends'
					onClick={() => setIsImportFormOpen(true)}
				/>
			</ContentWrapper>

			<SpendsTable spends={spends} />
			{isImportFormOpen && (
				<ImportSpendForm setShow={handleCloseForm} reload={loadData} />
			)}
		</PageWrapper>
	);
};

export default Spends;
